import api from "./utils/api";
import { getAuthToken } from "./utils/tokens";

const getNotifications = async () => {
  try {
    const token = getAuthToken();
    const data = await api.get("/notifications", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data.data;
  } catch (err) {
    throw err;
  }
};

const updateNotification = async (notificationId) => {
  try {
    const token = getAuthToken();
    const data = await api.put(
      `/notifications/${notificationId}/read`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data.data;
  } catch (err) {
    throw err;
  }
};

const updateAllNotification = async () => {
  try {
    const token = getAuthToken();
    const data = await api.put(
      `/notifications/read-all`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data.data;
  } catch (err) {
    throw err;
  }
};

const deleteNotification = async (notificationId) => {
  try {
    const token = getAuthToken();
    const data = await api.delete(`/notifications/${notificationId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data.data;
  } catch (err) {
    throw err;
  }
};

const deleteAllNotification = async () => {
  try {
    const token = getAuthToken();
    const data = await api.delete("/notifications/clear", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data.data;
  } catch (err) {
    throw err;
  }
};

// FOR ADMIN ONLY ("POST NOTIFICATIONS")

const postNotification = async (userId, title, body, data, category) => {
  try {
    const token = getAuthToken();
    const response = await api.post(
      `/notifications/send/${userId}`,
      {
        title,
        body,
        data,
        category,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

export {
  getNotifications,
  updateNotification,
  updateAllNotification,
  deleteNotification,
  deleteAllNotification,
  postNotification,
};
